import React from "react";
import { Route, Switch } from "react-router-dom";
import routes from "./constants/routes.json";
import App from "./containers/App";
import DashboardOverviewPage from "./containers/DashboardOverviewPage";
import LoginPage from "./containers/LoginPage";
import CardRegistrationPage from "./containers/CardRegistrationPage";
import UserPage from "./containers/UserPage";
import RolePage from "./containers/RolePage";
import ReportTicketLogPage from "./containers/ReportTicketLogPage";
import ReportCardLogPage from "./containers/ReportCardLogPage";
import RateCarPage from "./containers/RateCarPage";
import RateMotoPage from "./containers/RateMotoPage";
import RateTypePage from "./containers/RateTypePage";
import ShiftTypePage from "./containers/ShiftTypePage";
import ReportShiftLogPage from "./containers/ReportShiftLogPage";

export default function Routes() {
  return (
    <Switch>
      <Route exact path={routes.Login} component={LoginPage} />
      <App>
        <Route
          exact
          path={routes.DashboardOverview}
          component={DashboardOverviewPage}
        />
        <Route exact path={routes.RateCar} component={RateCarPage} />
        <Route exact path={routes.RateMoto} component={RateMotoPage} />
        <Route exact path={routes.RateType} component={RateTypePage} />
        <Route
          exact
          path={routes.CardRegistration}
          component={CardRegistrationPage}
        />
        <Route exact path={routes.ShiftType} component={ShiftTypePage} />
        <Route
          exact
          path={routes.ReportTicketLog}
          component={ReportTicketLogPage}
        />
        <Route
          exact
          path={routes.ReportCardLog}
          component={ReportCardLogPage}
        />
        <Route
          exact
          path={routes.ReportShiftLog}
          component={ReportShiftLogPage}
        />
        <Route exact path={routes.User} component={UserPage} />
        <Route exact path={routes.Role} component={RolePage} />
      </App>
    </Switch>
  );
}
